const initTextImageExtendedBlockReadMore = () => {
    const textTogglerNodeList = document.querySelectorAll("[data-text-toggler]");
    textTogglerNodeList.forEach((textToggler) => {
        textToggler.addEventListener("click", () => {
            textToggler.classList.toggle("active");
            textToggler.closest("[data-text-container]").querySelectorAll("[data-text-to-show]").forEach((textToShow) => {
                textToShow.classList.toggle("active");
            });
        });
    });
};
